import { render, staticRenderFns } from "./PendingSslIndicator.vue?vue&type=template&id=196f72e6&scoped=true"
import script from "./PendingSslIndicator.vue?vue&type=script&lang=js"
export * from "./PendingSslIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f72e6",
  null
  
)

export default component.exports